"use client";

import { c as _c } from "react/compiler-runtime";
import { gql } from "graphql-request";
import { toNumber } from "lodash";
import { useMemo, useState } from "react";
import ButtonLink from "src/components/buttonlink/ButtonLink";
import withWatchlistState from "src/components/filmwebid/withWatchlistState";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import SuspenseFallback from "src/components/suspensefallback/SuspenseFallback";
import RelatedClip from "src/components/traileroverlaywrapper/RelatedClip";
import WatchlistButton from 'src/components/traileroverlaywrapper/WatchlistButton';
import { useFilminfo } from "src/lib/client/useFilminfo";
import type IFilmklipp from "src/lib/types/Filmklipp";
import type { ITrailer } from "src/lib/types/Trailer";
import styles from './TrailerOverlayWrapper.module.css';
import { getMovieIdentifier } from "src/lib/filmwebid/useMovieIdentifier";

//#region [Props]
type TwentyThreeTrailerPlayerProps = {
  video?: ITrailer | IFilmklipp;
  videoId?: number;
  hideRelated?: boolean;
  onSelectTrailer?: (newTrailerId: number) => void;
};
//#endregion

//#region [Component]
export default function TwentyThreeTrailerPlayer(t0) {
  const $ = _c(25);
  const {
    video,
    videoId,
    hideRelated: t1,
    onSelectTrailer
  } = t0;
  const hideRelated = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== video || $[1] !== videoId) {
    t2 = () => {
      if (video?.videoId) {
        return toNumber(video.videoId);
      }
      return videoId;
    };
    $[0] = video;
    $[1] = videoId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [_videoId, setVideoId] = useState(t2);
  let t3;
  if ($[3] !== _videoId) {
    t3 = {
      clipId: _videoId
    };
    $[3] = _videoId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !!_videoId;
  let t5;
  if ($[5] !== t4) {
    t5 = {
      active: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const {
    fiLoading,
    fiData,
    isError
  } = useFilminfo(MOVIE_CLIP_QUERY, t3, t5);
  const movieClip = fiData?.movieQuery?.getMovieClip;
  let t6;
  if ($[7] !== movieClip) {
    bb0: {
      if (movieClip) {
        let t7;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
          t7 = /padding-bottom:(\d+(?:\.\d+))%/gim;
          $[9] = t7;
        } else {
          t7 = $[9];
        }
        const regExp = t7;
        const match = regExp.exec(movieClip.embedCode);
        if (match && match.length === 2) {
          const n = Number(match[1]);
          if (n > 100) {
            const newEmedCode = movieClip.embedCode.replace(match[1], "56.25");
            t6 = newEmedCode;
            break bb0;
          }
        }
        t6 = movieClip.embedCode;
        break bb0;
      }
      t6 = null;
    }
    $[7] = movieClip;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const embedCode = t6;
  if (!_videoId) {
    return null;
  }
  const isLoading = fiLoading && !movieClip && !embedCode;
  let t7;
  if ($[10] !== isLoading) {
    t7 = isLoading && <SuspenseFallback text="Henter trailer" />;
    $[10] = isLoading;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isError) {
    t8 = isError && <div className={styles.ErrorMessage}>Det oppstod en feil</div>;
    $[12] = isError;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== embedCode || $[15] !== hideRelated || $[16] !== isError || $[17] !== isLoading || $[18] !== movieClip || $[19] !== onSelectTrailer) {
    t9 = !isError && !isLoading && <article className={styles.SPlayerContainer}>{movieClip?.movieTitle && <h2 className={styles.SMovieTitle}><FilmwebLink className={styles.STitleLink} to={`/film/${movieClip.movieId}`}>{movieClip.movieTitle}</FilmwebLink></h2>}<h2 className={styles.SClipTitle}>{movieClip?.movieId ? <FilmwebLink className={styles.STitleLink} to={`/film/${movieClip.movieId}`}>{movieClip.clipTitle}</FilmwebLink> : <>{movieClip.clipTitle}</>}</h2><div className={styles.SPlayer} dangerouslySetInnerHTML={{
        __html: embedCode
      }} /><div className={styles.SOther}>{!hideRelated && (movieClip.relatedClips?.length ?? 0) > 0 && <div className={styles.SRelatedClips}>{movieClip.relatedClips.slice(0, 4).map(rc => <RelatedClip key={rc?.id} clip={rc} onClick={() => {
            setVideoId(rc.id);
            onSelectTrailer?.(rc.id);
          }} />)}</div>}</div><div className={styles.SActions}>{movieClip?.movieId && <div className={styles.SButtonPadder}><ButtonLink href={`/film/${movieClip.movieId}`}>Mer om filmen</ButtonLink><WButton movieIdentifier={getMovieIdentifier(movieClip)} /></div>}</div></article>;
    $[14] = embedCode;
    $[15] = hideRelated;
    $[16] = isError;
    $[17] = isLoading;
    $[18] = movieClip;
    $[19] = onSelectTrailer;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t10 = <>{t7}{t8}{t9}</>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
//#endregion

//#region [Component]
const WButton = withWatchlistState(WatchlistButton);
//#endregion

//#region [Other]
const MOVIE_CLIP_QUERY = gql`
query ($clipId: Int, $playerId: Int) {
    movieQuery {
        getMovieClip(clipId: $clipId, playerId: $playerId) {
            __typename
            clipTitle
            movieId
            movieTitle
            id
            embedCode
            sanityImageWideUrl
            relatedClips {
                __typename
                id
                clipTitle
                sanityImageWideUrl
            }
        }
    }
}
`;
//#endregion